module.exports = __webpack_public_path__ + "img/globe.ff76380b.svg";